export default {
  noSupport: '当前环境不支持分享'
}

